<template>
  <section id="team-config" class="page-content">
      <header id="section-header">
          <p class="title has-text-grey">Team Config</p>
          <p class="subtitle has-text-grey">Edit, create and delete Teams information.</p>
      </header>
      <main id="section-body">
          <button class="button is-primary is-small add-button" @click="team={coordinators:[], members:[]}; showModal=true">Add Team</button>
            <data-table
                :expand="['id']"
                :objects="_objects"
                :schema="schema"
                :totalItems="count"
                @expand="showTeamDetail($event)"
                >
                <div slot-scope="actions">
                  <modal-confirm
                  :disabled="false"
                  @confirm="deleteTeam(actions.object)">
                    <div slot="title">Confirm Delete</div>
                    <span slot="body">Are you sure you want to <strong>delete</strong> this team?</span>
                    <div slot="footer">
                      <button class="button" @click="showModal = false; $emit('close')">
                        No, I'm not
                      </button>
                      <button class="button is-primary" @click="showModal = false; $emit('confirm')">
                        Yes, I'm sure
                      </button>
                    </div>
                    <div slot="trigger" class="button is-success is-small">Delete</div>
                  </modal-confirm>
                </div>
            </data-table>
            <pagination
            :currentPage.sync="page"
            :totalItems="count"
            :itemsPerPage="pageSize"
            />

            <modal width="580px" v-if="showModal" @close="showModal=false">
              <div slot="header" style="font-family: MuseoSans-700; color: #138366;font-size:1.4em">
                {{team.name}}
              </div>
              <div slot="body">

                <div class="field field-inline">
                  <label class="label">Name</label>
                  <div class="control">
                    <input class="input" type="text" v-model="team.name" name="team_name" id="team_name">
                  </div>
                </div>
                <div class="field">
                  <label class="label">Coordinators</label>
                  <div class="event-code-container" style="max-height:215px; overflow-y: auto">
                      <ul style="column-count:2">
                      <li v-for="user in users" :key="user.id" >
                          <label class="checkBox" :for="'c'+user.id" v-on:click.capture.stop>
                              <input type="checkbox" :id="'c'+user.id" :value='user.id' v-model="team.coordinators">
                              <span class="checkmark"/>
                              <b>{{user.username}}:</b> {{ user.first_name + ' ' + user.last_name}}
                          </label>
                      </li>
                      </ul>
                  </div>
                </div>
                <div class="field">
                  <label class="label">Members</label>
                  <div class="event-code-container" style="max-height:215px; overflow-y: auto">
                      <ul style="column-count:2">
                      <li v-for="user in users" :key="user.id" >
                          <label class="checkBox" :for="'m'+user.id" v-on:click.capture.stop>
                              <input type="checkbox" :id="'m'+user.id" :value='user.id' v-model="team.members">
                              <span class="checkmark"/>
                              <b>{{user.username}}:</b> {{ user.first_name + ' ' + user.last_name}}
                          </label>
                      </li>
                      </ul>
                  </div>
                </div>

              </div>

              <div slot="footer">
                <button class="button is-primary" style="font-family: MuseoSans-900;text-transform: uppercase; border-radius: 6px;" @click="save()">
                  Save
                </button>
                <button class="button is-black" style="font-family: MuseoSans-900;text-transform: uppercase; border-radius: 6px;" @click="showModal=false">
                  Close
                </button>
              </div>
            </modal>
      </main>
  </section>
</template>

<script>
import {mapActions, mapState, mapGetters} from 'vuex'
import TagInput from '@/components/TagInput'
import DataTable from '@/components/DataTable'
import Modal from '@/components/Modal'
import ModalConfirm from '@/components/ModalConfirm'
import PaginatedFilteredListMixin from '@/pages/mixins/PaginatedFilteredListMixin'
import Pagination from '@/components/Pagination'

import Team from '@/models/team'

export default {
  name: 'user-config',
  components: {TagInput, DataTable, Pagination, Modal, ModalConfirm},
  mounted () {
    this.$emit('loading')
    if (!this.hasPermission('canWrite')) this.$router.push('dashboard')
    if (!this.isManager) { this.$router.push('dashboard') }
    const promises = [
      this.getPage(this.page),
      this.getUsers().then((response) => {
        this.users = response
      })
    ]
    Promise.all(promises).then(data => { this.$emit('loaded') })
  },
  mixins: [PaginatedFilteredListMixin],
  data () {
    return {
      schema: Team.schema(),
      objects: [],
      showModal: false,
      team: {members: [], coordinators: []},
      users: []
    }
  },
  computed: {
    ...mapState({
      count: state => state.team.count,
      isManager: state => state.isManager,
      pageSize: state => state.pageSize
    }),
    ...mapGetters({hasPermission: 'hasPermission'}),
    _objects: function () {
      var objects = JSON.parse(JSON.stringify(this.objects))
      objects.forEach(o => {
        o.members = o.members.map(x => { return x.first_name + ' ' + x.last_name })
        o.members = o.members.join(', ')
        o.coordinators = o.coordinators.map(x => { return x.first_name + ' ' + x.last_name })
        o.coordinators = o.coordinators.join(', ')
      })
      return objects
    }
  },
  methods: {
    ...mapActions({
      getTeam: 'team/retrieve',
      getObjects: 'team/list',
      getUsers: 'user/list',
      saveTeam: 'team/save',
      deleteT: 'team/delete'
    }),
    showTeamDetail (team) {
      this.getTeam(team.id).then(response => {
        this.team = response
        this.team.members = this.team.members.map(x => x.id)
        this.team.coordinators = this.team.coordinators.map(x => x.id)
        this.showModal = true
      })
    },
    save () {
      this.saveTeam(this.team).then(response => {
        this.getPage(this.page)
        this.team = {coordinators: [], members: []}
        this.showModal = false
      })
    },
    deleteTeam (team) {
      this.deleteT(team).then(response => {
        this.getPage(this.page)
      })
    }
  }
}
</script>
<style lang="scss">
    li{
      padding: .2em 0;
    }
    .add-button {
      margin: .5em 0;
    }
</style>




// WEBPACK FOOTER //
// src/pages/PageTeamsConfig.vue